const INFO = {
	main: {
		title: "Rithvik K",
		name: "Rithvik K",
		shortName: "Rithvik",
		email: "rithvikbng@gmail.com",
		logo: "/logo.png",
		resume: "/resumes/rithvik_s_resume (2).pdf",
	},

	socials: {
		twitter: "https://x.com/BngRithvik",
		github: "https://github.com/Rithvik1709",
		linkedin: "https://www.linkedin.com/in/rithvik1709/",
		stackoverflow: "https://stackoverflow.com/users/26624236/rithvik-k",
		medium: "https://medium.com/@rithvikbng",
	},

	homepage: {
		intro: [
			"I write Python, train models, and occasionally build things on blockchains. Lately that mostly means retrieval systems: RAG pipelines on Kubernetes, multimodal search with Qdrant, CLIP and Whisper.",
			"Outside of my own projects I mentor at GirlScript Summer of Code, lead the tech team at MLSA-CIT, and write about whatever I've just figured out on Medium.",
		],
		now: "Reading about vector databases and trying to make RAG less fragile in production.",
	},

	skills: [
		"Python",
		"TensorFlow",
		"LLMs & RAG",
		"Qdrant",
		"CLIP",
		"Whisper",
		"Kubernetes",
		"Azure AI",
		"Google Cloud",
		"Blockchain",
		"Web3",
		"React",
		"Node.js",
		"Flask",
		"Arduino",
		"CI/CD",
	],

	about: {
		title: "Apart from working in Tech, I love working in Open Source, Blogging and contributing to the community.",
		description:
			"Here are some highlights about my Open-source and Tech Talks journey so far:",
	},

	community: [
		{
			title: "GSSOC'24 Contributor",
			org: "GirlScript Summer of Code",
			description:
				"Contributed to open-source projects under GirlScript Summer of Code (GSSOC) by fixing issues, adding features, and collaborating with the developer community.",
		},
		{
			title: "GSSOC'25 Mentor",
			org: "GirlScript Summer of Code",
			description:
				"Started as a Contributor at GSSOC, later promoted to Mentor — guiding contributors, reviewing code, and supporting their learning journey.",
		},
		{
			title: "Google Cloud Arcade Facilitator '24 & '25",
			org: "Google Cloud",
			description:
				"Guided students through cloud labs, resolved queries, and encouraged hands-on learning with Google Cloud technologies.",
		},
		{
			title: "Winter of Blockchain Mentor",
			org: "WoB",
			description:
				"Guided contributors in blockchain development, reviewed projects, and fostered learning in decentralized technologies.",
		},
		{
			title: "Campus Ambassador",
			org: "Unstop",
			description:
				"Promoted hackathons and competitions, increased student engagement, and built awareness about career opportunities.",
		},
		{
			title: "Student Ambassador",
			org: "LetsUpgrade",
			description:
				"Facilitated workshops and helped peers enhance their coding skills through collaborative learning.",
		},
		{
			title: "Student Ambassador",
			org: "International Model United Nations",
			description:
				"Promoted global awareness and encouraged youth participation in diplomacy and international relations.",
		},
		{
			title: "Campus Ambassador",
			org: "Agnirva Space Community (by ISRO)",
			description:
				"Organized events and workshops to promote space education and awareness among students.",
		},
		{
			title: "Mentor",
			org: "Mentor Together",
			description:
				"Guided students in their learning journeys, providing support and resources for their development.",
		},
	],

	talks: [
		{
			title: "Building your portfolio using GitHub Copilot",
			host: "Azure Developer Community",
			description:
				"Spoke about leveraging AI tools like GitHub Copilot to enhance productivity and streamline the development process.",
		},
		{
			title: "Creating your first ML model with Google Cloud AutoML",
			host: "Google Developer Group — City Engineering College",
			description:
				"Workshop on building machine learning models with Google Cloud AutoML, guiding participants through training and deploying their own models.",
		},
		{
			title: "Boosting your LinkedIn presence",
			host: "Google Developer Group — City Engineering College",
			description:
				"Workshop on optimizing LinkedIn profiles and leveraging the platform for professional networking and opportunities.",
		},
	],

	work: [
		{
			company: "Reskilll",
			role: "Organiser",
			duration: "Oct 2024 — Present",
			logo: "/reskilll.jpg",
		},
		{
			company: "GSSOC'25",
			role: "Project Mentor",
			duration: "Jul 2025 — Dec 2025",
			logo: "/gs.jpg",
		},
		{
			company: "MLSA-CIT",
			role: "Technical Team Lead",
			duration: "Dec 2023 — Dec 2025",
			logo: "/mlsacit.jpg",
		},
		{
			company: "Microsoft Learn Student Ambassadors",
			role: "Beta MLSA",
			duration: "Aug 2024 — Dec 2025",
			logo: "/mlsa.jpg",
		},
		{
			company: "DeepLearning.AI",
			role: "Pie & AI Ambassador",
			duration: "Sep 2024 — Sep 2025",
			logo: "/deep.jpg",
		},
		{
			company: "Headstarter AI",
			role: "Software Engineer Intern",
			duration: "Jul 2024 — Jan 2025",
			logo: "/head.jpg",
		},
		{
			company: "Upskill Campus",
			role: "Machine Learning Intern",
			duration: "Jan 2024 — Jan 2025",
			logo: "/upskill.jpg",
		},
		{
			company: "E-Cell CIT",
			role: "UI/UX Designer",
			duration: "Sep 2023 — May 2024",
			logo: "/ecell.jpg",
		},
		{
			company: "Oasis Infobyte",
			role: "Python Developer Intern",
			duration: "Mar 2023 — Apr 2023",
			logo: "/Oasis.jpg",
		},
	],

	projects: [
		{
			title: "Documed",
			description: "A chatbot that answers medical questions and points people to the right information.",
			category: "AI",
			tags: ["Python", "AI"],
			link: "https://github.com/rithvik17-09/documed",
		},
		{
			title: "Local Voice Assistant",
			description: "A voice assistant for low-resource languages that works offline. Sets reminders, translates phrases, searches local information.",
			category: "AI",
			tags: ["Speech", "Offline"],
			link: "https://github.com/Rithvik1709/Local-voice-assistant",
		},
		{
			title: "Sora Reworked",
			description: "My take on Sora: one interface for text, image and code generation.",
			category: "AI",
			tags: ["GenAI"],
			link: "https://github.com/Rithvik1709/Sora_reworked",
		},
		{
			title: "Fake Product Identification",
			description: "Uses a blockchain to check whether a product is genuine or a counterfeit.",
			category: "Blockchain",
			tags: ["Blockchain"],
			link: "https://github.com/Rithvik1709/Fake-product-identification",
		},
		{
			title: "Smart Voting System",
			description: "Arduino hardware for casting votes, a blockchain for counting them.",
			category: "Blockchain",
			tags: ["Arduino", "Blockchain"],
			link: "https://github.com/Rithvik1709/Smart-voting-system-with-Arduino-blockchain",
		},
		{
			title: "Web3 Job Portal",
			description: "A decentralized job board for job seekers and employers.",
			category: "Blockchain",
			tags: ["Web3"],
			link: "https://github.com/Rithvik1709/Web3-job-portal",
		},
		{
			title: "Blockcode",
			description: "A shared code editor for classrooms, with real-time editing and sessions.",
			category: "Web",
			tags: ["Real-time"],
			link: "https://github.com/Rithvik1709/Blockcode",
		},
		{
			title: "Applyperfect",
			description: "Keeps job applications, resumes and interview prep in one place.",
			category: "Web",
			tags: ["Web"],
			link: "https://github.com/Rithvik1709/Applyperfect",
		},
		{
			title: "Stacked Image",
			description: "Combines a set of images into one grid. Handy for spotting stars in astronomy photos.",
			category: "Tools",
			tags: ["Python"],
			link: "https://github.com/Rithvik1709/stacked_image",
		},
		{
			title: "Audio & Image Compression",
			description: "Upload a file, get a smaller one back. Built with Flask.",
			category: "Tools",
			tags: ["Python", "Flask"],
			link: "https://github.com/Rithvik1709/audio-and-image-compression-using-flask",
		},
	],
};

export default INFO;
